export const soundFx = {
  data: function () {
    return {
      currentSoundName: '',
      _audio:null
    }
  },

  methods: {
    sfxPlay(soundName) {
        if(this._audio==null)
        {
            this._audio = new Audio();
        }
        this._audio.src = "sfx/"+soundName+".mp3"
        this._audio.play();
        //alert("sound name:"+soundName);
    },
  }
};
